// @ts-ignore
/* eslint-disable */
import request from "../../request";

/** 获取系统错误日志详情 GET /apiAdmin/log/error/${param0} */
export async function logControllerGetErrorLogById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.LogControllerGetErrorLogByIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultDataErrorLogDataDtoDto>(
    `/apiAdmin/log/error/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 删除错误日志 DELETE /apiAdmin/log/error/${param0} */
export async function logControllerDeleteErrorLog(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.LogControllerDeleteErrorLogParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/log/error/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 批量删除错误日志 DELETE /apiAdmin/log/error/batch */
export async function logControllerBatchDeleteErrorLog(
  body: { ids?: number[] },
  options?: { [key: string]: any }
) {
  return request<any>("/apiAdmin/log/error/batch", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 清空错误日志 DELETE /apiAdmin/log/error/clear */
export async function logControllerClearErrorLog(options?: {
  [key: string]: any;
}) {
  return request<any>("/apiAdmin/log/error/clear", {
    method: "DELETE",
    ...(options || {}),
  });
}

/** 处理错误日志（标记已处理/已忽略） POST /apiAdmin/log/error/handle */
export async function logControllerHandleErrorLog(
  body: API.HandleErrorLogDto,
  options?: { [key: string]: any }
) {
  return request<any>("/apiAdmin/log/error/handle", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取系统错误日志列表 POST /apiAdmin/log/error/list */
export async function logControllerGetErrorLogList(
  body: API.QueryErrorLogDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataErrorLogDataDtoPageDto>(
    "/apiAdmin/log/error/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取未处理错误日志数量 GET /apiAdmin/log/error/unhandled-count */
export async function logControllerGetUnhandledErrorCount(options?: {
  [key: string]: any;
}) {
  return request<any>("/apiAdmin/log/error/unhandled-count", {
    method: "GET",
    ...(options || {}),
  });
}

/** 删除登录日志 DELETE /apiAdmin/log/login/${param0} */
export async function logControllerDeleteLoginLog(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.LogControllerDeleteLoginLogParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/log/login/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 批量删除登录日志 DELETE /apiAdmin/log/login/batch */
export async function logControllerBatchDeleteLoginLog(
  body: { ids?: number[] },
  options?: { [key: string]: any }
) {
  return request<any>("/apiAdmin/log/login/batch", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 清空登录日志 DELETE /apiAdmin/log/login/clear */
export async function logControllerClearLoginLog(options?: {
  [key: string]: any;
}) {
  return request<any>("/apiAdmin/log/login/clear", {
    method: "DELETE",
    ...(options || {}),
  });
}

/** 获取登录日志列表 POST /apiAdmin/log/login/list */
export async function logControllerGetLoginLogList(
  body: API.QueryLoginLogDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataLoginLogDataDtoPageDto>(
    "/apiAdmin/log/login/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取操作日志详情 GET /apiAdmin/log/operation/${param0} */
export async function logControllerGetOperationLogById(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.LogControllerGetOperationLogByIdParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.ResultDataOperationLogDataDtoDto>(
    `/apiAdmin/log/operation/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 删除操作日志 DELETE /apiAdmin/log/operation/${param0} */
export async function logControllerDeleteOperationLog(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.LogControllerDeleteOperationLogParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<any>(`/apiAdmin/log/operation/${param0}`, {
    method: "DELETE",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 批量删除操作日志 DELETE /apiAdmin/log/operation/batch */
export async function logControllerBatchDeleteOperationLog(
  body: { ids?: number[] },
  options?: { [key: string]: any }
) {
  return request<any>("/apiAdmin/log/operation/batch", {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 清空操作日志 DELETE /apiAdmin/log/operation/clear */
export async function logControllerClearOperationLog(options?: {
  [key: string]: any;
}) {
  return request<any>("/apiAdmin/log/operation/clear", {
    method: "DELETE",
    ...(options || {}),
  });
}

/** 获取操作日志列表 POST /apiAdmin/log/operation/list */
export async function logControllerGetOperationLogList(
  body: API.QueryOperationLogDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataOperationLogDataDtoPageDto>(
    "/apiAdmin/log/operation/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取组织操作日志列表（organizationId从Token获取） POST /apiAdmin/log/operation/org/list */
export async function logControllerGetOrgOperationLogList(
  body: API.QueryOperationLogDto,
  options?: { [key: string]: any }
) {
  return request<API.ResultDataOperationLogDataDtoPageDto>(
    "/apiAdmin/log/operation/org/list",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
